module.exports = __webpack_public_path__ + "media/BNP_Samodzielniak_5_C_2.9e1c2c70.mp3";